module.exports = __webpack_public_path__ + "static/img/ht3.8bb85ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ht3.jpg
// module id = iBOL
// module chunks = 1